import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// import Admissionleft from './Admissoinleft';
import { Container, Row, Col, Button } from 'react-bootstrap';
import Fade from 'react-bootstrap/Fade';
import Scholarshipleft from './Scholarshipleft'

function PMVidyalaxmiSchemeEle() {

    const [datesOpen, setDatesOpen] = useState(true);
    const [guidelinesOpen, setGuidelinesOpen] = useState(false);
    
    
    const handleClick = (event) => {
        setDatesOpen(false);
        setGuidelinesOpen(false);       
        event(true);
    }

    return (
        <section className="project-detail">
            <Container>
                 <Container>
                                <Row className='mb-3'>
                                    <p className='caboutus'>IIT Tirupati encourages meritorious students by providing different types of scholarships and fee waiver. There are also some special scholarship schemes for SC, ST and female students. Some of the scholarships are given by the Government of India, while others are from various agencies. There are procedures for obtaining the scholarship and every scholarship application is thoroughly checked and verified before being approved. </p>
                                </Row>
                                </Container>
                <Row>
                    <Col md={4} className='c-left custom-padding-color mb-5'>
                        <Scholarshipleft activeIndex={3} />
                    </Col>

                    <Col md={8} className='c-right text-center'>

                        <div className="c-heading">
                            <h3>PM-Vidyalaxmi Scheme</h3> <br />
                        </div>
                        
                        


                        {/*dates */}
                    <div>
                        {datesOpen && <Fade in={datesOpen}>
                                <div className='lower-content'>
                                    <div id="services" className=" services-area fix col-lg-12 col-md-12">
                                        <div className="services-box text-left">
                                            <h4 class="caboutus"><p>The PM-Vidyalaxmi Scheme, a Government of India initiative offering collateral-free and guarantor-free education loans is available for all meritorious students who are getting admission in this Institution and who are desirous of availing education loans to pursue higher education. You can visit the portal <b><Link to="https://pmvidyalaxmi.co.in" className="c-link">Click Here</Link></b>. The portal does not charge any amount from the applicant.</p></h4>
                                            
                                            
                                        </div>
                                    </div>  
                            </div>
                        </Fade>
                    }
                    </div>


                        {/*Guidelines*/}
                        
                    {/* <div>
                            {guidelinesOpen && <Fade in={guidelinesOpen}>
                                <div className='lower-content'>
                                    <div id="services" className=" services-area fix col-lg-12 col-md-12">
                                        <div className="services-box text-left">
                                            <h4><p>Apply Online</p></h4>

                                            <div className="services-content2">
                                                <b>To Apply Online :</b> <Link to="https://iittp.plumerp.co.in/prod/iittirupati/" className="c-link">Click Here</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </Fade>
                    }
                </div> */}
            </Col>
        </Row>
    </Container>
        </section>
    );
}

export default PMVidyalaxmiSchemeEle;
